import { render } from "./RegisterView.vue?vue&type=template&id=863b584e"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=863b584e&lang=css"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__